import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { NBXStorage } from '@nbx/frontend-helpers/storage';

const STORAGE_KEY = 'location.from';

export const useWriteRedirectAfterLogin = () => {
  const location = useLocation();

  useEffect(() => {
    const from = location?.state?.from;
    from && NBXStorage.setItem(STORAGE_KEY, from.pathname + from.search);
  }, [location]);
};
